import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
const get = require('lodash/get');

import WithEndUserFeaturedDemos from '../DataHOCs/WithEndUserFeaturedDemos';
import FeaturedDemoTile from './FeaturedDemoTile';
import Navigator from '../../Navigator';

const propTypes = {
    className: PropTypes.string,
    history: PropTypes.object.isRequired,
    featuredDemos: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired, // activity id
            project_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            owner_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        })
    ).isRequired,
};

const defaultProps = {
    className: '',
};

function FeaturedDemoArea(props) {
    if (props.featuredDemos.length === 0) {
        return null;
    }

    return (
        <div className={props.className}>
            <div className="margin-bottom-md">
                <h2 className="section-title inline-block">Featured Demos</h2>
            </div>
            <div className="fd-row">
                {props.featuredDemos.map((demo) => {
                    return (
                        <FeaturedDemoTile
                            key={demo.id}
                            demo={demo}
                            interactable
                            onSelect={() => Navigator.goToActivityView(props.history, demo.owner_id, demo.project_id, demo.id)}
                        />
                    );
                })}
            </div>
        </div>
    );
}

export default withRouter(WithEndUserFeaturedDemos(FeaturedDemoArea));